import { ephanApi } from './requests';

/**
 * Змагання з публічного API e-phan.
 *
 * Календар читає їх живцем, як і каталоги танцюристів чи суддів: копії в нашій
 * базі немає (ADR-0012).
 *
 * Кожна функція повертає пару `[error, data]` — контракт задає перехоплювач
 * у requests.js.
 */

const today = () => new Date().toISOString().slice(0, 10);

/**
 * Календар: усе від сьогодні й далі.
 *
 * Саме `dateFrom`, а не `period=upcoming`: у джерела захід, що триває сьогодні,
 * вважається `ongoing` і в «майбутні» не потрапляє — календар втратив би його
 * рівно в дні проведення.
 *
 * Без фільтра за країною: e-phan веде змагання не лише України (ADR-0012
 * зафіксувала це як помилку — фільтр `country=UA` лишав календар порожнім),
 * і відвідувачу цікаві закордонні старти теж. Які з них не українські,
 * позначає `eventFromCompetition.isUkrainian` на боці сайту.
 */
export const getCompetitionsFetch = () =>
  ephanApi.get(`/competitions?dateFrom=${today()}&sort=startDate&order=asc&limit=100&page=1`);

/** Архів: від найсвіжішого, сторінками. */
export const getCompetitionsArchiveFetch = (page = 1, limit = 24) =>
  ephanApi.get(`/competitions?period=past&sort=startDate&order=desc&limit=${limit}&page=${page}`);

/** Одне змагання. Джерело приймає і слаг, і UUID. */
export const getCompetitionFetch = (slug) => ephanApi.get(`/competitions/${encodeURIComponent(slug)}`);
